export function planIndexForAcceptedLine(
  lines: ReadonlyArray<{ skip: boolean }>,
  acceptedIndex: number,
): number | null {
  if (!Number.isInteger(acceptedIndex) || acceptedIndex < 0) return null;
  let acceptedSeen = -1;
  const index = lines.findIndex((line) => {
    if (line.skip) return false;
    acceptedSeen += 1;
    return acceptedSeen === acceptedIndex;
  });
  return index >= 0 ? index : null;
}
